import React from 'react';
import PropTypes from 'prop-types';

class BackToTemplatesButton extends React.PureComponent {
  static trackBackToTemplatesClick() {
    window._track('End Demo', 'Template Builder');
  }

  render() {
    if (this.props.isSampleState) {
      return (
        <div className={`back-to-templates-link-wrapper ${this.props.isOpenPostBuilderSidePanel ? 'side-panel-open' : ''}`}>
          <a
            className="back-to-templates-link"
            href="/myFillableFields.php"
            onClick={BackToTemplatesButton.trackBackToTemplatesClick}
          >
            {this.props.buttonText}
          </a>
        </div>
      );
    }
    return null;
  }
}

BackToTemplatesButton.defaultProps = {
  buttonText: 'BACK TO MY TEMPLATES',
};

BackToTemplatesButton.propTypes = {
  buttonText: PropTypes.string,
  isSampleState: PropTypes.bool.isRequired,
  isOpenPostBuilderSidePanel: PropTypes.bool.isRequired,
};

export default BackToTemplatesButton;



// WEBPACK FOOTER //
// ./src-react/SelfServeBuilder/SelfServeBuilderToolbar/BackToTemplatesButton.jsx